import { Form, Slider, Typography } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { bergScaleOptions } from "../../../Options/physioOptions";
import { notAssessableAndAssessableOptions } from "../../../Options/commonOptions";
import DeselectableRadioGroup from "../../../../../blocks/FormItems/DeselectableRadioGroup";

const BergScale = ({ context, form }) => {
  const [refresh, setRefresh] = useState(false);
  const { formData } = useContext(context);
  const [states, setStates] = useState({});
  useEffect(() => {
    const { status, score, interpretation, ...filteredBerg } =
      formData?.systemic_examination?.berg_scale || {};
    setStates(filteredBerg);
  }, [formData]);

  const calculateScore = () => {
    const score = Object.values(states)?.reduce(
      (acc, cur) => acc + (cur || 0),
      0
    );
    form.setFieldValue(["berg_scale", "score"], score);
    return score;
  };

  const score = calculateScore();

  const handleChange = (value, key) => {
    setStates((prev) => ({ ...prev, [key]: value }));
  };

  const getInterpretation = () => {
    const string =
      score > 40
        ? "Low Fall Risk, Independent"
        : score > 20
        ? "Moderate Fall Risk, Walking with Assistance"
        : "High Fall Risk, Wheel Chair Bound";
    form.setFieldValue(["berg_scale", "interpretation"], string);
    return string;
  };

  const interpretation = getInterpretation();

  return (
    <div className="physio-scales initial">
      <DeselectableRadioGroup
        label={"Berg Balance Scale"}
        name={["berg_scale", "status"]}
        options={notAssessableAndAssessableOptions}
        form={form}
        setRefresh={setRefresh}
      />
      <Form.Item name={["berg_scale", "score"]} hidden />
      <Form.Item name={["berg_scale", "interpretation"]} hidden />
      {form.getFieldValue(["berg_scale", "status"]) === "assessable" && (
        <div className="subsection-card">
          <Typography style={{ textAlign: "center" }}>
            {score} : {interpretation}
          </Typography>

          {bergScaleOptions.map((option) => (
            <Form.Item
              key={option.name}
              label={option.label}
              name={["berg_scale", option.value]}
            >
              <Slider
                marks={{ 0: "0", 1: "1", 2: "2", 3: "3", 4: "4" }}
                max={4}
                min={0}
                style={{ width: "70%" }}
                onChange={(value) => handleChange(value, option.value)}
                className="selection-slider"
              />
            </Form.Item>
          ))}
        </div>
      )}
    </div>
  );
};

export default BergScale;
